import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IAccessRequestListStyles {
  root?: IStyle;
  cardView?: IStyle;
  description?: IStyle;
  descriptionText?: IStyle;
  filter?: IStyle;
}

export interface IAccessRequestListClassNames {
  root: string;
  cardView: string;
  description?: string;
  descriptionText?: string;
  filter?: string;
}

export const accessRequestListStylesDefault = (theme: IH2OTheme): Partial<IAccessRequestListStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  description: {
    color: theme.semanticColors?.textSecondary,
    display: 'flex',
    justifyContent: 'space-between',
  },
  descriptionText: {
    marginTop: 8,
    marginBottom: 8,
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
});
